<template>
  <div class="tab-pane fade" id="estimate_people" role="tabpanel" aria-labelledby="estimate_people-tab">
    <div class="container-fluid">
      <div>
        <div class="row">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary">
              東管處_人數推估設定
            </div>
            <div class="row">
              <div class="col-12">
                <table :class="tableStyle">
                  <thead class="table-dark text-center">
                    <tr>
                      <th scope="col" width="10%">#</th>
                      <th scope="col" width="20%">類型</th>
                      <th scope="col" width="35%">目前設定平均載客人數</th>
                      <th scope="col" width="35%">修改設定</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in internalEstimateList.filter(e => e.passengerType !== 'suv')" :key="key"
                      :class="tableCenterStyle">
                      <td>{{ key + 1 }}</td>
                      <td>{{ CONST.ESTIMATE_DAT_TYPE[item.dayType] }}</td>
                      <td>{{ CONST.ESTIMATE_CAR_TYPE[item.passengerType] + ' : ' + item.averageNumber }}</td>
                      <td>
                        <button class="btn btn-primary bg-indigo" @click="editEstimate(item)">
                          編輯
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <hr />
        <!--人數推估設定-->
        <div class="row">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary">
              觀光署_人數推估設定
            </div>
            <div class="row">
              <div class="col-12">
                <table :class="tableStyle">
                  <thead class="table-dark text-center">
                    <tr>
                      <th scope="col" width="10%">#</th>
                      <th scope="col" width="20%">類型</th>
                      <th scope="col" width="35%">目前設定平均載客人數</th>
                      <th scope="col" width="35%">修改設定</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in externalEstimateList" :key="key" :class="tableCenterStyle">
                      <td>{{ key + 1 }}</td>
                      <td>{{ CONST.ESTIMATE_DAT_TYPE[item.dayType] }}</td>
                      <td>{{ CONST.ESTIMATE_CAR_TYPE[item.passengerType] + ' : ' + item.averageNumber }}</td>
                      <td>
                        <button class="btn btn-info" @click="editEstimate(item)">
                          編輯
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <dialog-modal ref="estimateEditor" :showUpdateButton="true" customUpdateButton="修改" :modalSize="''" :isImage="false"
      :isMarginAuto="false" @update-button-click="updateEstimate">
      <div class="pb-1" v-if="selectEstimate != null"> <!--using v-if for avoid to selectScenicArea is not defined -->
        <div class="form-group h6">
          <label for="exampleInputEmail1">{{ CONST.ESTIMATE_CAR_TYPE[selectEstimate.passengerType] }}</label>
          <input type="number" class="form-control" min="0" step='0.1' v-model.number="selectEstimateNumber" />
        </div>
      </div>
    </dialog-modal>
    <!-- Modal -->
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from 'vuex'
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import { getCountPerHour } from '../../api/elasticSearch/vehicleplateApi'
import exportCSV from '../../utils/exportCSV'
import DialogModal from '../../components/DialogModal.vue'


export default {
  data() {
    return {
      CONST: CONST,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      selectScenicArea: null,
      internalEstimateList: [],
      externalEstimateList: [],
      selectEstimate: null,
      selectEstimateNumber: 0,
    };
  },
  computed: {
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
    ...mapState("passengerEstimateSetting", { estimateDataList: "allEstimateData" }),
  },
  watch: {
    estimateDataList() {
      for (let i = 0; i < this.estimateDataList.length; i++) {

        if (this.estimateDataList[i].isInternal === 'true') {
          this.internalEstimateList = this.estimateDataList[i][CONST.ESTIMATE_KEY]
        } else {
          this.externalEstimateList = this.estimateDataList[i][CONST.ESTIMATE_KEY]
        }
      }
    }
  },
  methods: {
    editEstimate(item) {
      this.$refs.estimateEditor.openModal()
      this.selectEstimate = item
      this.selectEstimateNumber = this.selectEstimate.averageNumber
    },

    async updateEstimate() {
      if( this.selectEstimateNumber < 0 ) {
            alert("推估參數不可以為負數")
            return
      }
      this.selectEstimate.averageNumber = this.selectEstimateNumber
      const result = await this.$store.dispatch('passengerEstimateSetting/putEstimate', this.selectEstimate)

      if (result.success) {
        this.$refs.estimateEditor.closeModal();
        this.$store.dispatch('passengerEstimateSetting/getEstimate')
      } else {
        alert('修改失敗')
      }
    }
  },
  mounted() {
    this.$store.dispatch('passengerEstimateSetting/getEstimate')
  },
  components: { DialogModal },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
</style>
